import React, {useEffect} from 'react';
import {BASE_URL} from 'config';
import {getLegacyPortalTarget} from 'utils/migratedPortal';

export default function MigratedPortalRedirect({portal, location}) {
  const target = getLegacyPortalTarget(portal, location?.pathname, BASE_URL);
  useEffect(() => {
    window.location.replace(target);
  }, [target]);
  return <a href={target}>Continue to Jidipi</a>;
}
